import React, { useEffect, useState } from 'react';
import useGlobal from '../../store';
import LoadingOverlay from '../General/LoadingOverlay';
import ReactGA from 'react-ga';
import * as utils from '../../services/utils';
import CurrencySymbol from '../General/CurrencySymbol';
import PopoverNotice from '../General/PopoverNotice';

const ItemCard = (props) => {

    const [ui, actions] = useGlobal(
        state => state,
        actions => actions
    );
    useEffect(() => {

    }, [ui]);

    const [isLoading, setIsLoading] = useState(false);

    const domain = function(input) {
        if(!input || input === "") {
            return "";
        }
        input = Array.isArray(input) ? input[0] : input;
        input = input.replace('www.', '');
        var l = document.createElement("a");
        l.href = input;
        return l.hostname;
    }

    const getItemUrl = (item) => {
        if(item.affURL) {
            return item.affURL;
        }
        if(!item.itemURLs || item.itemURLs === "") {
            return "#";
        }
        if(item.itemURLs.indexOf('amazon.com') !== -1 
            || item.itemURLs.indexOf('amazon.co.uk') !== -1
            || item.itemURLs.indexOf('amazon.de') !== -1
            || item.itemURLs.indexOf('amazon.fr') !== -1
            || item.itemURLs.indexOf('amazon.es') !== -1) {
            return formatAmazonUrl(item.itemURLs);
        } else if(item.itemURLs.includes("target.com")) {
            var t = item.itemURLs.match(/.*A-(.*?)($|#|\?)/);
            if(t && t.length > 1) {
                return 'https://goto.target.com/c/1430766/520943/2092?prodsku=' + t[1] + '&u=' + encodeURIComponent(item.itemURLs) + '&intsrc=PUI1_4061';
            }
        }
        return "http://go.redirectingat.com/?id=86675X1539295&xs=1&url="+encodeURI(item.itemURLs)+"&sref="+encodeURI(window.location.href);
    }
    const formatAmazonUrl = (linkUrl) => {
        linkUrl = decodeURIComponent(linkUrl);
        if(linkUrl.indexOf('christmasli0b-20') === -1) {
            var parts = linkUrl.split("?");
            if(parts.length > 1) {
                var params = JSON.parse('{"' + decodeURI(parts[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
                params.tag = "christmasli0b-20";
                var queryString = Object.keys(params)
                        .map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) })
                        .join('&');
                linkUrl = parts[0] + "?" + queryString;
            } else {
                linkUrl += "?tag=christmasli0b-20"; 
            }
        }
        return linkUrl;
    }

    const openLink = (item) => {
        let itemUrl = getItemUrl(item);
        if(!itemUrl || itemUrl === "#") {
            return;
        }
        window.open(itemUrl, '_blank');

        //TRACK REFERRAL CLICK EVENT
        let domain = utils.getDomain(item.itemURLs);
        let evtVal = item.price ? parseInt(item.price, 10) : 1;
        ReactGA.event({
            category: 'Referral Click',
            action: 'MyGiftlist Item',
            label: domain,
            value: evtVal
        });
    }

    const openSidePanel = (panelName) => {
        actions.uiActions.toggleSidePanel(panelName, props);
    }

    const removeItem = () => {
        actions.giftlistActions.removeItem(props.itemID);
        setIsLoading(true);
    }
    return ( 
        <div className="card item-card">
            {isLoading ? <LoadingOverlay height="10rem" width="10rem"></LoadingOverlay> : <></> }
            <div className="kt-padding-10 text-center card-top" onClick={() => openLink(props)}>
                {props.itemPic && props.itemPic !== "" ? <img src={props.itemPic} alt="Item" /> : <></> }
                {props.itemPrice && props.itemPrice > 0 
                   ? <div className="badge badge-primary price-tag">
                        <h4 className="p-0 m-0"><CurrencySymbol></CurrencySymbol>{props.itemPrice} <i className="la la-external-link"></i></h4>
                </div> : <></> }
            </div>
            <div className="card-body" onClick={() => openLink(props)}>
                <h5 className="card-title">{props.itemName}</h5>
                { (props.itemURLs && props.itemURLs !== "") ? 
                    <>
                    <p id={'item_' + props.itemID} style={{"display":"inline-block"}} className="card-text">{domain(props.itemURLs)} <i className="flaticon2-tag"></i>
                    { (domain(props.itemURLs) === "amazon.com" && props.itemPrice && props.itemPrice > 0) ? <><br/>price as of {utils.formatDateString(props.created)}</> : <></> }
                    </p>
                    <PopoverNotice title={'Link opens ' + domain(props.itemURLs)} trigger='hover' body='We earn small commissions on some purchases you make through our links. Thank you for supporting us.' placement='top' target={'item_' + props.itemID} ></PopoverNotice>
                    </>
                : <></> }
                
                <p className="card-text">{props.itemDescription}</p>
            </div>
            <div className="card-footer text-right">
                <button onClick={() => openSidePanel('edititem')} className="btn btn-info mr-2">Edit</button>
                <button className="btn btn-danger" onClick={() => removeItem()}>Remove</button>
            </div>
        </div>);
}
export default ItemCard;